





















































































































import { snakeCase } from 'lodash'
import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'

import { MessageEditorComponentSettings } from "../../../types";
import ButtonsManager from '../logic/ButtonsManager'
import { ButtonBuildersGroups } from '../logic/types'
import ButtonSettingsView from './ButtonSettingsView.vue'
import ButtonsListCard from './ButtonsListCard.vue'

@Component({
  components: {
    ButtonsListCard,
    ButtonSettingsView,
  },
  data() {
    return {
      ButtonBuildersGroups,
      snakeCase,
    }
  }
})
export default class ButtonsCreator extends Vue {
  @Prop() buttonsManager!: ButtonsManager

  @Prop() buttonsHelpView!: MessageEditorComponentSettings['buttonsHelpView']

  @Watch('buttonsManager.selectedButton')
  selectedButtonWatcher(button: any): void {
    if (button) {
      this.addedButton = true
    }
  }

  addedButton = true
}
